import {Component, Input, inject} from '@angular/core';
import {Booking} from '../../../../core/entities/booking/booking.entity';
import {CurrencyPipe} from '@angular/common';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {Router} from '@angular/router';
import {AppImageComponent} from '../../../../core/components/image/image';

@Component({
  selector: 'app-booking-item',
  imports: [
    TranslocoPipe,
    CurrencyPipe,
    AppImageComponent
  ],
  templateUrl: './booking-item.component.html',
  styleUrl: './booking-item.component.scss'
})
export class BookingItemComponent {
  @Input() booking!: Booking;

  private readonly router = inject(Router);
  private readonly transloco = inject(TranslocoService);

  public goToBooking(event?: Event): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    this.router.navigate(['/manage/booking', this.booking.id]);
  }

  public hasDiscount(): boolean {
    return this.isServiceDiscountActive() && this.getServiceDiscount() > 0;
  }

  public getDiscountPercentage(): number {
    return this.hasDiscount() ? this.getServiceDiscount() : 0;
  }

  public getFinalPrice(): number {
    const withMethod = this.callBookingMethod('getPrice');
    if (typeof withMethod === 'number') {
      return withMethod;
    }

    return this.booking.price ?? this.booking.service.price ?? 0;
  }

  public getFormattedDate(): string {
    const locale = this.transloco.getActiveLang() || 'en';
    const date = this.booking.datetime.setLocale(locale);
    const uses24h = locale !== 'en';
    const format = uses24h ? 'EEEE d MMMM yyyy, HH\'h\'mm' : 'EEEE d MMMM yyyy hh:mma';
    const formatted = date.toFormat(format);

    return uses24h ? formatted : formatted.replace('AM', 'am').replace('PM', 'pm');
  }

  private callBookingMethod(method: 'getPrice'|'getPublicPrice'): number | null {
    const maybeMethod = (this.booking as any)?.[method];
    if (typeof maybeMethod !== 'function') {
      return null;
    }

    const result = maybeMethod.call(this.booking);
    return typeof result === 'number' ? result : null;
  }

  private isServiceDiscountActive(): boolean {
    return !!((this.booking.service as any)?.discountActive);
  }

  private getServiceDiscount(): number {
    const raw = (this.booking.service as any)?.discount;
    if (typeof raw !== 'number') {
      return 0;
    }

    return Math.round(raw);
  }
}
